import AiAnalysisResult from "./AiAnalysisResult";
import RelatedKeyword from "./RelatedKeyword";
import MeasurementResult from "./MeasurementResult";

export default function DetailAppleZone({data, img}) {
    return (
        <MeasurementResult type="애플존" description='"애플존"은 일반적으로 얼굴의 뺨 부분을 가리킵니다. 애플존은 얼굴의 외모를 더욱 화사하고 청순하게 만들어주는 특징적인 부분 중 하나로 여겨집니다. 많은 사람들이 볼살이 높고 풍성한 애플존을 가지고 있으면 더욱 어려보이고 건강하게 보입니다.' 
        score={data.score}>
            <div className="row-wrap">
                <div className="img-wrap">
                    <div className="img-cont">
                        <img src={img.image_cross_polar_front} />

                        <div className="caption">2D</div>
                    </div>
                    {/* <div className="img-cont detail">
                        <div className="img">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_detail_01.png"} />
                        </div>
                        <div className="img">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_detail_01.png"} />
                        </div>
                    </div> */}
                </div>
                <section>
                    <p className="body3">
                        애플존은 뺨과 이마 사이에 위치한 부분으로, 얼굴의 형태와 인상을 결정짓는 중요한 부분 중 하나입니다. 이 지역의 피부는 탄력이 감소하고 늘어나는 경향이 있으며, 이로 인해 주름이 생길 수 있습니다.
                    </p>
                </section>
            </div>

            <div className="row-wrap grow">
                <RelatedKeyword list={data.keyword} />

                <AiAnalysisResult 
                    text={data.aiResult} 
                />
            </div>
        </MeasurementResult>
    )
}